import type { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { ImputedBadge } from '@/components/common/items-data-table/cells/ImputedBadge';
import { OverflowTooltip } from '@/components/ui/OverflowTooltip';
import { TIMELINE_ITEM_IMPUTED_FIELD } from '@/lib/api/types/loop-planner/timeline-item';
import type { ItemsTableRow } from '../types';

export const EstimationDisplayCell = ({ value, row }: GridRenderCellParams<ItemsTableRow>) => {
  const isImputed = row.imputedFields?.includes(TIMELINE_ITEM_IMPUTED_FIELD.ESTIMATION) ?? false;

  if (!value) {
    return null;
  }

  if (!isImputed) {
    return <OverflowTooltip>{value}</OverflowTooltip>;
  }

  return (
    <div className="flex items-center gap-2 min-w-0">
      <ImputedBadge />
      <OverflowTooltip>{value}</OverflowTooltip>
    </div>
  );
};
